var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "profile-icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M64,16c0,-8.831 -7.169,-16 -16,-16l-32,0c-8.831,0 -16,7.169 -16,16l0,32c0,8.831 7.169,16 16,16l32,0c8.831,0 16,-7.169 16,-16l0,-32Z",
    style: {
      fill: "url(#profile-icon-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "shadow",
    d: "M21.167,55.317l-0,-14.15c-0,-0.46 0.373,-0.834 0.833,-0.834c0.46,0 0.833,0.374 0.833,0.834l0,14.667c2.687,0.739 5.821,1.166 9.167,1.166c3.347,0 6.48,-0.427 9.167,-1.165l-0,-14.668c-0,-0.46 0.373,-0.834 0.833,-0.834c0.46,0 0.833,0.374 0.833,0.834l0,14.15c1.421,-0.495 2.678,-1.084 3.73,-1.744c2.415,-1.516 3.768,-3.439 3.768,-5.462l-0,-0.001c-0.003,-2.047 0.086,-6.122 -0.706,-9.648c-0.568,-2.532 -1.611,-4.774 -3.344,-5.957c-0.275,-0.188 -0.709,-0.321 -1.273,-0.367c-0.821,-0.067 -2.012,0.025 -3.255,0.028l-0.387,-0.002c-0.885,-0.012 -1.783,-0.08 -2.552,-0.331c-0.631,-0.206 -1.174,-0.536 -1.482,-1.118c-0.145,-0.273 -0.42,-0.433 -0.708,-0.443l-0.041,-0c-0.127,0.001 -0.257,0.033 -0.377,0.096l-0.126,0.082l-0.084,0.076c-1.191,0.925 -2.531,1.474 -3.996,1.474c-1.503,-0 -2.875,-0.578 -4.088,-1.546l-0.003,0.007l-0.139,-0.093l-0.137,-0.057l-0.12,-0.029l-0.154,-0.01l-0.138,0.015l-0.135,0.038l-0.127,0.06l-0.115,0.082l-0.102,0.101l-0.084,0.121l-0.015,0.026c-0.308,0.582 -0.85,0.912 -1.482,1.118c-0.769,0.251 -1.666,0.319 -2.551,0.331l-0.259,0.002c-0.903,0.002 -1.783,-0.046 -2.522,-0.052l-0.862,0.024c-0.563,0.046 -0.997,0.179 -1.273,0.367c-1.733,1.184 -2.772,3.426 -3.336,5.958c-0.784,3.526 -0.686,7.6 -0.688,9.647l0,0.001c0,2.023 1.353,3.946 3.768,5.462c1.052,0.66 2.309,1.249 3.729,1.744Zm10.833,-48.317c-6.799,0 -8.333,5.71 -8.333,8.889c-0,2.944 1.079,6.882 2.997,9.562c1.387,1.937 3.213,3.216 5.336,3.216c2.123,-0 3.949,-1.279 5.336,-3.216c1.918,-2.68 2.997,-6.618 2.997,-9.562c0,-3.179 -1.534,-8.889 -8.333,-8.889Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "profile-icon-gradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(64,64,-64,64,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD0FA",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e4c3ff",
      stopOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8c03f8cb2960ff3cf3ee058b5e11d7f5.svg";
export { ForwardRef as ReactComponent };